import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { Fragment } from "react";
import { q } from "./api.ts";
import { factUnlocks } from "./fact-playbooks.ts";
import { list } from "./format.ts";
import { FACT_LABEL, FACT_PLAYBOOK_LABELS as L } from "./labels.ts";
import { ErrorText } from "./ui.tsx";
import { Skeleton } from "./ui/skeleton.tsx";

/** What confirming facts makes possible, from the same requirements planning enforces. */
export function FactPlaybooks({ productId, factKey, account }: { productId: string; factKey?: string; account?: boolean }) {
  const library = useQuery(q.playbookLibrary(productId));
  if (library.isLoading) return <Skeleton shape="text" rows={1} />;
  if (!library.data) return <ErrorText error={library.error} />;
  const groups = factUnlocks(library.data.playbooks, factKey, account);
  if (!groups.length) return null;
  return <div className="z-flow">
    {groups.map((group) => <p className="z-small" key={JSON.stringify([group.facts, group.repository])}>
      <span className="z-muted">{(group.repository ? L.withRepository : L.confirm)(list(group.facts.map((key) => FACT_LABEL[key] ?? key)))} </span>
      {group.playbooks.map((playbook, index) => <Fragment key={playbook.id}>
        {index > 0 && L.separator}
        <Link className="z-link" to="/playbooks/$playbookId" params={{ playbookId: playbook.id }} search={{ product: productId }}>{playbook.title}</Link>
      </Fragment>)}
    </p>)}
    <ErrorText error={library.error} />
  </div>;
}
